import { ResponsiveVisibility, Text, Skeleton, Stack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../../../store/home/capture/atom';

export namespace AssetNetValueTypes {
  export interface Props {
    assetNetValue?: number;
    visibility?: ResponsiveVisibility;
    loading?: boolean;
  }
}

export const AssetNetValue: React.FC<AssetNetValueTypes.Props> = ({
  assetNetValue,
  visibility = 'visible',
  loading,
}) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);
  const sanitizedVisibility: NonNullable<ResponsiveVisibility> = visibility ?? {};
  const currentVisibility = useBreakpointValue(
    typeof sanitizedVisibility === 'string' ? { base: sanitizedVisibility } : sanitizedVisibility
  );

  if (currentVisibility === 'hidden') {
    return null;
  }

  if (loading) {
    return (
      <Stack
        space={Spacing['stack.nano']}
        justifyContent={{ base: 'space-between', sm: 'inherit' }}
        direction={{ base: 'row', sm: 'column' }}
        flex={{ base: 1, sm: 'inherit' }}
        width="80px">
        <Skeleton height="inset.sm" width="full" borderRadius="sm" />
        <Skeleton height="inset.sm" width="full" borderRadius="sm" />
      </Stack>
    );
  }

  return (
    <Stack
      justifyContent={{ base: 'space-between', sm: 'inherit' }}
      direction={{ base: 'row', sm: 'column' }}
      flex={{ base: 1, sm: 'inherit' }}>
      <Text
        variant={{ base: 'semibold', sm: 'regular' }}
        fontSize={{ base: Typography['fontsize.xs'], sm: Typography['fontsize.md'] }}
        color="neutral.medium">
        PATRIMÔNIO TOTAL
      </Text>
      <Text
        fontSize={{ base: Typography['fontsize.xs'], sm: Typography['fontsize.lg'] }}
        variant="semibold"
        letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
        {valueVisibility ? Utils.Mask.ScaleMoney(assetNetValue) : Typography['bullet.sequence']}
      </Text>
    </Stack>
  );
};
